<div class="d-flex flex-wrap gap-2">
  <span i18n>Determination of Benefits by Final Location:</span>&ngsp;
  <span *ngIf="finalLocationId !== null; else defaults">{{ finalLocationId | governingJurisdictionName }}</span>
  <ng-template #defaults><span i18n>Default(s)</span></ng-template>
</div>
